module.exports = __webpack_public_path__ + "media/pdf/Vereinbarung_zur_Auftragsverarbeitung-c882e194909a00d00aeb3e8c0406412e.pdf";